const url = '/companies';
const Provider = 'Companies';
const dbModel = 'Companies';

export { url, Provider, dbModel };
